import { useState, useEffect } from 'react'
import debounce from 'lodash/debounce'

export function useDebouncedValue<T>(value: T, delay: number): T {
    const [debouncedValue, setDebouncedValue] = useState(value)

    useEffect(() => {
        const handler = debounce((v: T) => {
            setDebouncedValue(v)
        }, delay)

        handler(value)
        return () => {
            handler.cancel()
        }
    }, [value, delay])

    return debouncedValue
}
